import { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/macro";

export const shopTypeTranslation: Record<string, MessageDescriptor> = {
  ["women"]: msg`Women`,
  ["men"]: msg`Men`,
  ["kids"]: msg`Kids`,
  ["all"]: msg`All`,
};
